"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _scheduledMessages = require('shared/actions/scheduledMessages');
var _store = require('shared/store');



/* Cancel on a Scheduled bubble, with Undo. The server can't take a cancel
 * back, so the command waits: the bubble hides at once, and the cancel is
 * sent when the toast's Undo runs out, when staff leave the chat, or when
 * they leave the app. Undo before then just shows the bubble again. A
 * message due within the window is cancelled at once, with no Undo.
 *
 * It lives outside React so a waiting cancel outlasts the screen that
 * started it: it is sent late, never dropped. */

// How long the toast offers Undo.
 const UNDO_WINDOW_MS = 6000; exports.UNDO_WINDOW_MS = UNDO_WINDOW_MS
// A message due this soon after the window closes is cancelled at once, so
// the cancel can't reach the server after the send has started.
const SEND_MARGIN_MS = 2000

/* The toast a chat shows after Cancel: the latest cancel there. */























const pending = new Map()
let toasts = {}
const toastTimers = new Map()
const listeners = new Set()

const setToast = (conversationKey, toast) => {
  if (toast) toasts = { ...toasts, [conversationKey]: toast }
  else {
    if (!toasts[conversationKey]) return
    const rest = { ...toasts }
    delete rest[conversationKey]
    toasts = rest
  }
  listeners.forEach(listener => listener())
}

const showToast = (conversationKey, toast) => {
  clearTimeout(toastTimers.get(conversationKey))
  toastTimers.set(conversationKey, setTimeout(() => {
    toastTimers.delete(conversationKey)
    if (toasts[conversationKey] === toast) setToast(conversationKey, null)
  }, exports.UNDO_WINDOW_MS))
  setToast(conversationKey, toast)
}

// Takes down the chat's toast if it is this cancel's and still offers Undo.
const dropUndo = (conversationKey, key) => {
  const toast = toasts[conversationKey]
  if (_optionalChain([toast, 'optionalAccess', _ => _.key]) !== key || !toast.undoable) return
  clearTimeout(toastTimers.get(conversationKey))
  toastTimers.delete(conversationKey)
  setToast(conversationKey, null)
}

// Sends a waiting cancel now. The bubble stays hidden until the server
// answers: on success the reducer drops the row, on a refusal it comes back.
const send = (key) => {
  const entry = pending.get(key)
  if (!entry || entry.sending) return
  if (entry.timer) clearTimeout(entry.timer)
  entry.timer = null
  entry.sending = true
  dropUndo(entry.conversationKey, key)
  const finish = () => {
    pending.delete(key)
    _store.dispatch.call(void 0, _scheduledMessages.actionCreators.unhideScheduledMessageAction(key))
  }
  _actions2.default.cancelScheduledMessage({ ConversationKey: entry.conversationKey, ScheduledMessageKey: key })
    .then(finish, (error) => {
      finish()
      entry.onError(error)
    })
}

const cancel = ({ conversationKey, message, onError, now = Date.now() }) => {
  const key = message.ScheduledMessageKey
  if (pending.has(key)) return
  // This toast replaces the chat's last one, and with it that one's Undo.
  const previous = toasts[conversationKey]
  if (_optionalChain([previous, 'optionalAccess', _2 => _2.undoable])) send(previous.key)

  _store.dispatch.call(void 0, _scheduledMessages.actionCreators.hideScheduledMessageAction(key))
  // An unreadable send time counts as due.
  const undoable = Date.parse(message.SendAt) - now >= exports.UNDO_WINDOW_MS + SEND_MARGIN_MS
  const entry = { conversationKey, timer: null, sending: false, onError }
  pending.set(key, entry)
  showToast(conversationKey, { key, undoable, expiresAt: now + exports.UNDO_WINDOW_MS })
  if (undoable) entry.timer = setTimeout(() => send(key), exports.UNDO_WINDOW_MS)
  else send(key)
}

// Takes back a cancel not yet sent: the bubble shows again.
const undo = (key) => {
  const entry = pending.get(key)
  if (!entry || entry.sending) return
  if (entry.timer) clearTimeout(entry.timer)
  pending.delete(key)
  _store.dispatch.call(void 0, _scheduledMessages.actionCreators.unhideScheduledMessageAction(key))
  dropUndo(entry.conversationKey, key)
}

// Leaving a chat: its waiting cancels go now, and its toast goes with it.
const commitChat = (conversationKey) => {
  pending.forEach((entry, key) => {
    if (entry.conversationKey === conversationKey) send(key)
  })
  clearTimeout(toastTimers.get(conversationKey))
  toastTimers.delete(conversationKey)
  setToast(conversationKey, null)
}

// Leaving the app: every waiting cancel goes now.
const commitAll = () => {
  pending.forEach((_entry, key) => send(key))
}

// For useSyncExternalStore: the toast changes for some chat.
const subscribe = (listener) => {
  listeners.add(listener)
  return () => { listeners.delete(listener) }
}

// The chat's toast, the same object until it changes.
const toastFor = (conversationKey) =>
  (conversationKey && toasts[conversationKey]) || null

exports. default = { cancel, undo, commitChat, commitAll, subscribe, toastFor }
